export const orgTypes = [
  {
    id: 0,
    value: 'OWNER',
  },
  {
    id: 1,
    value: 'CUSTOMER',
  },
  {
    id: 2,
    value: 'MANUFACTURER',
  },
  {
    id: 3,
    value: 'DEVICE MANAGER',
  },
  {
    id: 4,
    value: 'MAINTENANCE',
  },
];

export const roles = [
  {
    id: 0,
    value: 'OWNER',
  },
  {
    id: 1,
    value: 'MANAGER',
  },
  {
    id: 2,
    value: 'LEADER',
  },
  {
    id: 3,
    value: 'MEMBER',
  },
];
